import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class TourInstallerResetImmoTaskNotExecutedControllerRequestService {
  private static BASE_URL = '/tourInstaller/resetImmoTaskNotExecuted';
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) =>
    res as ResetImmoTaskNotExecutedResponse;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      TourInstallerResetImmoTaskNotExecutedControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public resetNotExecuted(
    immoTaskId: number
  ): Promise<ResetImmoTaskNotExecutedResponse> {
    return this.post(`/${immoTaskId}`, null, this.deserialize).toPromise();
  }
}

export interface ResetImmoTaskNotExecutedResponse {
  executed: string;
}
